module.exports = __webpack_public_path__ + "img/pattern.083a3e1.svg";